import useFetchManifestInfo from '../../../../hooks/useFetchManifestInfo';

type Props = {
  manifestNo: string;
};

const InfoItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className='row mt-2'>
      <div className='col-6'>
        <span className='global-text-16'>{label}</span>
      </div>
      <div className='col-6 boldglobaltext text-text-uppercase text-break'>
        {value}
      </div>
    </div>
  );
};

const ManifestGeneralInfo = ({ manifestNo }: Props) => {
  const { data, isLoading } = useFetchManifestInfo({ manifestNo });

  const info = data?.content || {};

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>General Info</h5>
      </div>
      <div className='card-body pt-2 p-4 h-auto'>
        {isLoading && (
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'></span>
          </div>
        )}
        {!isLoading && (
          <div className='row'>
            <div className='col-6'>
              <InfoItem
                label='Created Date'
                value={info.created_date || 'N/A'}
              />
              <InfoItem label='No (Manifest No)' value={manifestNo || 'N/A'} />
              <InfoItem label='Vehicle' value={info.vehicle || 'N/A'} />
              <InfoItem
                label='Carrier Name'
                value={info.carrier_name || 'N/A'}
              />
              <InfoItem
                label='Delivery Waybill No'
                value={info.delivery_waybill_no || 'N/A'}
              />
            </div>
            <div className='col-6'>
              <InfoItem label='Waybill No' value={info.waybill_no || 'N/A'} />
              <InfoItem
                label='Registration No'
                value={info.registration_no || 'N/A'}
              />
              <InfoItem label='Closed' value={info.closed ? 'Yes' : 'No'} />
              <InfoItem label='Invoiced' value={info.invoiced ? 'Yes' : 'No'} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManifestGeneralInfo;
